/**
 * Get property option shorthand
 * @param {String} name
 * @returns {Map<"name" | "rest", String>}
 */
const getPropertyOptionShorthand = (name) => {
  switch (true) {
    /**
     * Iterations
     * @example `<3x>`
     */
    case /\dx$|infinite/.test(name):
      return new Map([
        ["name", "iterations"],
        ["rest", name],
      ]);

    /**
     * Duration
     * @example `<1s>`
     */
    case /(\ds|\dms)$/.test(name):
      return new Map([
        ["name", "duration"],
        ["rest", name],
      ]);

    /**
     * Easing
     * @example `<spring>`
     */
    case /^(spring|elastic|ease|linear|bezier)/.test(name):
      return new Map([
        ["name", "easing"],
        ["rest", name],
      ]);

    /**
     * Direction
     * @example `<alternate>`
     */
    case /alternate|reversed/.test(name):
      return new Map([
        ["name", "direction"],
        ["rest", name],
      ]);

    /**
     * Skip first step
     * @example `<skip-first>`
     */
    case /skip-first/.test(name):
      return new Map([
        ["name", "skip-first"],
        ["rest", "true"],
      ]);

    /**
     * Reference shorthand
     * @example `@start-loop`
     */
    case /^@/.test(name):
      return new Map([
        ["name", "on_-_start"],
        ["rest", name],
      ]);

    /**
     * Default
     */
    default:
      return new Map([
        ["name", ""],
        ["rest", ""],
      ]);
  }
};

export default getPropertyOptionShorthand;
